/**
 * @Author : ShaJiaJing
 * @Date : 2019/6/4
 * @Version : 1.0
 * @Content : 仪表盘配置
 */
export default {
  common: {
    details: 'Details',
    expireDate: 'Expire date',
    robot: 'Robot',
    status: 'status',
    today: 'Today',
    yesterday: 'Yesterday',
    lastWeek: 'Last Week',
    lastThirty: 'Last Thirty'
  },
  quantifier: {
    day: '天'
  },
  first: {
    title: 'Robot running live',
    detail: {
      title: 'Robot details',
      robot: '@:dashboard.common.robot: ',
      process: 'Process: ',
      currentState: 'Current State: ',
      startTime: 'Start Time: ',
      endTime: 'End Time: '
    },
    recentTask: {
      title: 'Recently executed task'
    }
  },
  second: {
    title: 'Designer state',
    remainDays: '{day} day remaining',
    expireDate: '@:dashboard.common.expireDate:'
  },
  third: {
    title: 'Robot state',
    name: 'name',
    days: 'Remaining',
    status: 'Status',
    expireDate: '@:dashboard.common.expireDate'
  },
  fourth: {
    title1: 'Robot working status',
    title2: 'System available process',
    title3: 'Completed the task in the past 24 hours',
    title4: 'Failure task in the past 24 hours',
    nums: '{n}',
    normal: 'no normal | {n} normal',
    using: 'no enabled | {n} enabled',
    fault: 'no fault | {n} fault | {n} faults',
    timeout: 'no timeout | {n} timeout | {n} timeouts',
    error: 'no exception | {n} exception | {n} exceptions',
    stopped: 'no stopped | {n} stopped | {n} stopped'
  },
  fifth: {
    title: 'Task time trend'
  },
  sixth: {
    title: 'Failure trend'
  }
}
